import { useMutation, useQueryClient } from "@tanstack/react-query";
import cancelAppointment from "../../controllers/appointments/cancel-appointment";

const useCancelAppointmentMutation = () => {
  return useMutation(cancelAppointment, {});
};

export default useCancelAppointmentMutation;
